import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from "react";

import { Image as BaseImage } from "@imagekit/next";

import { type ImageTransformation, getImageUrlEndpoint, getImgUrlReplaceBe } from "@/shared.utils/image";

import { PttProps, ptt } from "../util.props-to-tailwind/props-to-tailwind";

const shimmer = (w: number, h: number) => {
  return `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#f0f0f0" offset="20%" />
      <stop stop-color="#e8e8e8" offset="50%" />
      <stop stop-color="#f0f0f0" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#f0f0f0" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;
};

const toBase64 = (str: string) => {
  return typeof window === "undefined"
    ? Buffer.from(str).toString("base64")
    : window.btoa(str);
};

interface ImageProps extends
  Omit<ComponentPropsWithoutRef<typeof BaseImage>, "src">,
  Partial<Pick<PttProps, "object" | "rounded" | "shadow">> {
  src: string;
  transformation?: ImageTransformation[];
}

const Image = (props: ImageProps) => {
  const {
    className,
    fill = true,
    object,
    placeholder,
    rounded,
    shadow,
    src: baseSrc,
    ...imageProps
  } = props;

  return (
    <BaseImage
      {...imageProps}
      urlEndpoint={getImageUrlEndpoint()}
      src={getImgUrlReplaceBe({ imgPath: baseSrc })}
      className={ptt({
        className,
        object,
        rounded,
        shadow,
      })}
      fill={fill}
      placeholder={placeholder || `data:image/svg+xml;base64,${toBase64(shimmer(300, 300))}`}
    />
  );
};

export { Image };
